module.exports = "<div *ngIf=\"game\">\n\n  <h2>GameKey: {{game.id | uppercase}}</h2>\n\n</div>\n"